/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { Container } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

function AuthFooter(props) {
  return (
    <footer className={"footer" + (props.default ? " footer-default" : "")}>
      <Container fluid={props.fluid ? true : false}>
        <div style={{color: "#DDD"}}>
          &copy; {1900 + new Date().getYear()}, 
          Codificado por{" "}
          <a
            href="https://smartmetrics.mx/"
            target="_blank"
          >
            SmartMetrics
          </a>
          .
        </div>
      </Container>
    </footer>
  );
}

AuthFooter.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default AuthFooter;